import { API_BASE_URL, API_BASE_URL2, API_BASE_URL3 } from "../config";

const api = {
  /* -------------------- Core Helpers -------------------- */
  get: async (endpoint, params = {}) => {
    const url = new URL(`${API_BASE_URL3}/${endpoint}`);
    const dbKey = sessionStorage.getItem("databaseKey");
    if (dbKey && !params.databaseKey) {
      params.databaseKey = dbKey;
    }

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    const response = await fetch(url);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP GET error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  post: async (endpoint, body = {}) => {
    const databaseKey = sessionStorage.getItem("databaseKey");
    const url = new URL(`${API_BASE_URL3}/${endpoint}`);
    if (databaseKey) {
      url.searchParams.append("databaseKey", databaseKey);
    }

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP POST error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  postForm: async (endpoint, formData) => {
    const databaseKey = sessionStorage.getItem("databaseKey");
    const url = new URL(`${API_BASE_URL3}/${endpoint}`);
    if (databaseKey) {
      url.searchParams.append("databaseKey", databaseKey);
    }

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP POST error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  /* -------------------- API Endpoints -------------------- */

  // ✅ Login
  AssetCheckLogin: (userName, userpwd) =>
    api.post("AssetCheckLogin", { UserName: userName, Userpwd: userpwd }),

  // ✅ Dashboard Card Summary List
  GetQcDashBoardList_API: (userName, databaseKey) =>
    api.get("GetQcDashBoardList_API", {
      UserName: userName,
      databaseKey: databaseKey,
    }),

  // ✅ Dashboard Detail Data (includes Status parameter)
  GetQcDashBoardValuesList_API: (userName, status, databaseKey) =>
    api.get("GetQcDashBoardValuesList_API", {
      UserName: userName,
      Status: status,
      databaseKey: databaseKey,
    }),
  GetQcMasterList_API: (userName, databaseKey) =>
    api.get("GetQcMasterList_API", {
      UserName: userName,
      databaseKey: databaseKey,
    }),

     VendorsTeamList_API: (userName, databaseKey) =>
    api.get("VendorsTeamList_API", {
      UserName: userName,
      databaseKey: databaseKey,
    }),
  DashBoardQcEntryList_API: (Gipid, userName, databaseKey) =>
    api.get("DashBoardQcEntryList_API", {
      Gipid: Gipid,
      UserName: userName,
      databaseKey: databaseKey,
    }),
  GetQcAssetList_API: (userName, databaseKey) =>
    api.get("GetQcAssetList_API", {
      UserName: userName,
      databaseKey: databaseKey,
    }),
  SupplierUserExplrList_API: (userName, databaseKey) =>
    api.get("SupplierUserExplrList_API", {
      UserName: userName,
      databaseKey: databaseKey,
    }),

  GetSupplierList_API: (userName, databaseKey) =>
    api.get("GetSupplierList_API", {
      UserName: userName,
      databaseKey: databaseKey,
    }),

 SaveVendorsTeam_API: (
  Sp_SqlAction,
  VTID,
  vid,
  vcode,
  vname,
  empName,  
  designation,
  active,
  UserName,
  databaseKey
) =>
  api.post(`SaveVendorsTeam_API?databaseKey=${databaseKey}`, {
    Sp_SqlAction,
    VTID,
    vid,
    vcode,
    vname,
    empName, 
    designation,
    Active: active,
    UserName,
  }),
    
  GetQcAssetList_API: (Gipid,Itemid,userName, databaseKey) =>
    api.get("GetQcAssetList_API", {
      Gipid: Gipid,
      Itemid:Itemid,
      UserName: userName,
      databaseKey: databaseKey,
    }),

  SaveSupplierUser_API: (Sp_SqlAction, usrid, vid, vcode, vname, email, userName, passWord, active, mobileNo, databaseKey) =>
    api.post("SaveSupplierUser_API", {
      Sp_SqlAction: Sp_SqlAction,
      usrid: usrid,
      vid: vid,
      vcode: vcode,
      vname: vname,
      email: email,
      UserName: userName,
      passWord: passWord,
      active: active,
      mobileNo: mobileNo,
      databaseKey: databaseKey,
    }),

   QcrejectionType_API: (userName, databaseKey) =>
     api.get("QcrejectionType_API", {
       UserName: userName,
       databaseKey: databaseKey,
     }),

   EditQcrejectionType_API: (QcSeqId, Gipid, userName, databaseKey) =>
     api.get("EditQcrejectionType_API", {
       QcSeqId: QcSeqId,
       Gipid: Gipid,
       UserName: userName,
       databaseKey: databaseKey,
     }),

     InspectionDetailsRpt_API: (Vid,userName, databaseKey) =>
    api.get("InspectionDetailsRpt_API", {
      Vid: Vid,
      UserName: userName,
      databaseKey: databaseKey,
    }),
  
  DMLQcRejectionDetails_API: (payload) => api.post("DMLQcRejectionDetails_API", payload),
  UpdateInspectionTools_API: (payload, databaseKey, userName) =>
    api.post(
      `/UpdateInspectionTools_API?databaseKey=${databaseKey}&UserName=${userName}`,
      payload
    ),
  StartInspectionEntry_API: async (bodyParams, databaseKey) => {
    return await api.post("StartInspectionEntry_API", bodyParams, databaseKey);
  },
  UpdateInspectionQty_API: async (bodyParams, databaseKey) => {
    return await api.post("UpdateInspectionQty_API", bodyParams, databaseKey);
  },

  QcgrnFinishedUpadate_API: (Gipid, UserName) =>
    api.post("QcgrnFinishedUpadate_API", {
      Gipid: Gipid,
      UserName: UserName,
    }),
    SaveItemQcInspectionParam_API: (payload, databaseKey, userName) =>
  api.post(
    `/SaveItemQcInspectionParam_API?databaseKey=${databaseKey}`,
    {
      Itemid: payload.Itemid,
      Partno: payload.Partno,
      UserName: userName,
      ItemTbl: payload.ItemTbl,
    }
  ),
     EditInspectionParam_API: (Itemid,userName, databaseKey) =>
     api.get("EditInspectionParam_API", {
       Itemid: Itemid,
       UserName: userName,
       databaseKey: databaseKey,
     }),
 GetInspectionDatas_API: (VId, Itemid, Fromdate, Todate, userName, databaseKey) =>
  api.get("GetInspectionDatas_API", {
    UserName: userName,
    VId: VId,
    Itemid: Itemid,
    Fromdate: Fromdate,
    Todate: Todate,
    databaseKey: databaseKey,
  }),
     InspReportSupplier_API: (userName, databaseKey) =>
       api.get("InspReportSupplier_API", {
         UserName: userName,
         databaseKey: databaseKey,
       }),
   
     InspectionDetailsRpt_API: (Vid, userName, databaseKey) =>
       api.get("InspectionDetailsRpt_API", {
         Vid: Vid,
         UserName: userName,
         databaseKey: databaseKey,
       }),
   
   
   
   }

api.UploadAttachment = async (formData) => {
  const databaseKey = sessionStorage.getItem("databaseKey");
  const url = `${API_BASE_URL3}/api/UploadAttachment?databaseKey=TRIALSPFL&`;
 // const url = `${API_BASE_URL3}/api/UploadAttachment?`;
  const response = await fetch(url, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) throw new Error(`Upload failed! ${response.status}`);
  return response.json();
};

// ✅ Get attachments for a record
api.GetAttachments = async (MdlId, PrimeId) => {
  //const databaseKey = sessionStorage.getItem("databaseKey");
  const url = new URL(`${API_BASE_URL3}/api/GetAttachments?databaseKey=TRIALSPFL&`);
  //const url = `${API_BASE_URL3}/api/GetAttachments?`;


  url.searchParams.append("mdlId", MdlId);
  url.searchParams.append("primeId", PrimeId);

  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch attachments`);
  return response.json();
};

// ✅ Delete attachment by ID
api.DeleteAttachment = async (id) => {
  const databaseKey = sessionStorage.getItem("databaseKey");
  //const url = new URL(`${API_BASE_URL2}/api/DeleteAttachment?databaseKey=TRIALSPFL&`);
  const url = `${API_BASE_URL3}/api/DeleteAttachment?`;
  if (databaseKey) {
    url.searchParams.append("databaseKey", databaseKey);
  }
  url.searchParams.append("id", id);

  const response = await fetch(url, { method: "DELETE" });
  if (!response.ok) throw new Error("Failed to delete attachment");
  return response.json();
};



api.uploadInspectionReport = async (data) => {
  const databaseKey = sessionStorage.getItem("databaseKey");
  const url = new URL(`${API_BASE_URL3}/InspectionReportUpload`);
  if (databaseKey) {
    url.searchParams.append("databaseKey", databaseKey);
  }
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) throw new Error(`Upload failed! ${response.status}`);
  return response.json();
};

export default api;

